import { WarehouseServices } from "../services/orders/pricelist-offers-get-by-id/types";

export const setWarehouseServicesEnum = (value: string) => {
  switch (value) {
    case "Składowanie":
      return WarehouseServices.Skladowanie;
    case "Crossdocking":
      return WarehouseServices.Crossdocking;
    case "Fullfilment":
      return WarehouseServices.Fullfilment;
    case "Etykietowanie":
      return WarehouseServices.Etykietowanie;
    case "Pakowanie":
      return WarehouseServices.Pakowanie;
    case "Sortowanie":
      return WarehouseServices.Sortowanie;
    case "E-commerce":
      return WarehouseServices.E_commerce;
    case "Wysyłka":
      return WarehouseServices.Wysylka;
    case "Inne":
      return WarehouseServices.Inne;
    case "Przyjecie towaru":
      return WarehouseServices.Przyjecie_towaru;
    case "Wydanie towaru":
      return WarehouseServices.Wydanie_towaru;
  }
};
export const getWarehouseServicesEnum = (type: WarehouseServices) => {
  switch (type) {
    case WarehouseServices.Skladowanie:
      return "Składowanie";
    case WarehouseServices.Crossdocking:
      return "Crossdocking";
    case WarehouseServices.Fullfilment:
      return "Fullfilment";
    case WarehouseServices.Etykietowanie:
      return "Etykietowanie";
    case WarehouseServices.Pakowanie:
      return "Pakowanie";
    case WarehouseServices.Sortowanie:
      return "Sortowanie";
    case WarehouseServices.E_commerce:
      return "E-commerce";
    case WarehouseServices.Wysylka:
      return "Wysyłka";
    case WarehouseServices.Inne:
      return "Inne";
    case WarehouseServices.Przyjecie_towaru:
      return "Przyjecie towaru";
    case WarehouseServices.Wydanie_towaru:
      return "Wydanie towaru";
  }
};
